
export default {
    setCursos(state, data) {
        state.cursos = data
    },
    setCurso(state, data) {
        state.curso = data
    },
}